var subscription_inject = document.querySelector(".recharge-subscription-widget")
var subscription_labels = document.querySelectorAll(".rc-template__radio .rc-radio__label")

if (subscription_inject && !subscription_labels[0]) {
	// Options for the observer (which mutations to observe)
	const config = { attributes: false, childList: true, subtree: true }

	// Callback function to execute when mutations are observed
	const callback = (mutationList, observer) => {
		var subscription_labels = document.querySelectorAll(".rc-radio")
		if (!subscription_labels[0]) return
		observer.disconnect() //do once

		var sub_extra_content = document.querySelector(".recharge-extra-content")

		Array.from(subscription_labels).forEach(function (label) {
			var label_copy = label.querySelector(".rc-radio__label")
			sepPrice(label_copy)

			if (sub_extra_content) {
				//add extra content to subscription
				var input = label.querySelector("input")

				if (input && input.value == "subscription") {
					var parser = new DOMParser()
					var new_html = parser.parseFromString(sub_extra_content.innerHTML, "text/html")

					// Get the body element from the parsed HTML
					var bodyElement = new_html.body

					// Append the child nodes (the parsed HTML) to the label
					while (bodyElement.firstChild) {
						label.appendChild(bodyElement.firstChild)
					}
				}
			}
		})
	}

	// Create an observer instance linked to the callback function
	const observer = new MutationObserver(callback)

	// Start observing the target node for configured mutations
	observer.observe(subscription_inject, config)
}
if (subscription_labels[0]) {
}

function sepPrice(label_el) {
	const price_el = label_el.querySelector(".rc-radio__price")
	if (price_el) return
	var label = label_el.innerHTML
	var price = label.split(" ")
	var new_label = label.replace(price[price.length - 1], '<span class="rc-radio__price">' + price[price.length - 1] + "</span>")
	label_el.innerHTML = new_label
}
